import { ROL_USER } from "../../app/api-client/constants"

export const menuPoll = () => {

    const rol = localStorage.getItem(ROL_USER)
    switch (rol) {

            case "ROLE_ADMIN":
                return (
                    [
                        {
                            id: 29,
                            rol: "ROLE_ADMIN",
                            icon: "poll",
                            label: "Encuestas",
                            type: "menu",
                            to: "/Pollpanel",
                            isOpen: true,
                            component: "Poll",
                            submenus: [
                                {
                                    id: 30,
                                    icon: "assignmentTurnedIn",
                                    label: "Estaciones",
                                    show: false,
                                    type: "submenu",
                                    to: "/polls/result/:id/:idBas",
                                    component: "PollResult"
                                },
                                {
                                    id: 31,
                                    icon: "assignmentTurnedIn",
                                    label: "Preguntas",
                                    show: false,
                                    type: "submenu",
                                    to: "/polls/preguntas/:id",
                                    component: "PanelQuestion"
                                },
                                {
                                    id: 37,
                                    icon: "assignmentTurnedIn",
                                    label: "Respuestas",
                                    show: false,
                                    type: "submenu",
                                    to: "/polls/preguntas/respuestas/:id/:idPoll",
                                    component: "PanelResponse"
                                },
                                {
                                    id: 38,
                                    icon: "results",
                                    label: "resultados",
                                    show: false,
                                    type: "submenu",
                                    to: "/polls/results/:id",
                                    component: "graphicResults"
                                },
                                {
                                    id: 39,
                                    icon: "results",
                                    label: "resultados por usuario",
                                    show: false,
                                    type: "submenu",
                                    to: "/polls/resultsUSer/:id",
                                    component: "resultadoDeUsuario"
                                },
                
                            ],
                        },
                        
    
                    ]
                )

                case "ROLE_USER":
                    return (
                        [
                            // {
                            //     id: 29,
                            //     rol: "ROLE_USER",
                            //     icon: "",
                            //     label: "",
                            //     type: "menu",
                            //     to: "/poll/encuestas/:id",
                            //     isOpen: false,
                            //     show: false,
                            //     component: "Poll",
                            //     submenus: [
                            //         {
                            //             id: 30,
                            //             icon: "assignmentTurnedIn",
                            //             label: "Estaciones",
                            //             show: false,
                            //             type: "submenu",
                            //             to: "/polls/result/:id/:idBas",
                            //             component: "PollResult"
                            //         },
                            //         {
                            //             id: 31,
                            //             icon: "assignmentTurnedIn",
                            //             label: "Preguntas",
                            //             show: false,
                            //             type: "submenu",
                            //             to: "/polls/preguntas/:id",
                            //             component: "PanelQuestion"
                            //         },
                    
                            //     ],
                            // },
                            
        
                        ]
                    )
                    case "ROLE_CLIENT":
                        return (
                            [
                                {
                                    id: 29,
                                    rol: "ROLE_ADMIN",
                                    icon: "poll",
                                    label: "Encuestas",
                                    type: "menu",
                                    to: "/Pollpanel",
                                    isOpen: true,
                                    component: "Poll",
                                    submenus: [
                                        {
                                            id: 30,
                                            icon: "assignmentTurnedIn",
                                            label: "Estaciones",
                                            show: false,
                                            type: "submenu",
                                            to: "/polls/result/:id/:idBas",
                                            component: "PollResult"
                                        },
                                        {
                                            id: 31,
                                            icon: "assignmentTurnedIn",
                                            label: "Preguntas",
                                            show: false,
                                            type: "submenu",
                                            to: "/polls/preguntas/:id",
                                            component: "PanelQuestion"
                                        },
                        
                                    ],
                                },
                                
            
                            ]
                        )

      


    
        default:
            return ([])
    }

}